//是否开启 mock模拟数据
let isMock = false;
export default isMock